import type { z } from 'zod';

import type { ValidationError } from './validation-error-types';

export function zodIssuesToValidationErrors(
  issues: z.core.$ZodIssue[]
): ValidationError[] {
  return issues.map((issue) => ({
    message: issue.message,
    path: issue.path as (string | number)[],
  }));
}
